// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nli {\r\n  padding: 10px;\r\n  text-align: center;\n}\n.exportsetting {\r\n  height: 180px;\r\n  background: rgb(255, 255, 255) !important;\r\n  border: 1px solid rgb(245, 245, 245);\r\n  box-shadow: rgb(220 212 212) 0px 1px 5px;\r\n  padding: 30px;\r\n  border-radius: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
